import { formatHotkeySymbols } from "./formatHotkey.js";
import ScalarHotkey_default from "./ScalarHotkey.vue.js";
export { ScalarHotkey_default as ScalarHotkey, formatHotkeySymbols };
